
export const PublicRoutesList = [
    { path: 'services', element: "Service" },
    { path: 'contact', element: "Contact" },
]